module.exports = __webpack_public_path__ + "img/dfe7a792d85cfd1483b03228fd1d51a383a3c7b5.d96a6e36.png";